import BASE_URL from "../config";

const authHeaders = () => {
  const token = localStorage.getItem("adminToken");
  return token
    ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
};

export const getProductOptions = async (productId) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/options`);
  return response.json();
};

export const createOptionGroup = async (productId, group) => {
  const response = await fetch(`${BASE_URL}/products/${productId}/options`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(group),
  });
  return response.json();
};

export const updateOptionGroup = async (groupId, group) => {
  const response = await fetch(`${BASE_URL}/options/${groupId}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(group),
  });
  return response.json();
};

export const deleteOptionGroup = async (groupId) => {
  const response = await fetch(`${BASE_URL}/options/${groupId}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  return response.json();
};
